var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPuzzle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 35,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.773 22.18c-5.862 2.97-7.726-4.986-2.898-5.26 2.364-.245 2.37 1.213 3.337.475s.282-8.487-.539-8.177c-6.94 2.614-11.85 3.447-21.437 3.589-.876.013.889 7.007 2.026 7.438 1.138.431.726-.967 3.063-1.41 4.354-.344 5.302 6.69-1.271 5.87-2.67-.333.224 9.46.224 9.46l7.178-1.704c-2.81-6.36 1.502-6.323 1.86-6.378 2.902-.268 4.384 1.364 2.723 6.822l8.363-.66s-.228-11.283-2.629-10.066M14.833 4.415c.41 2.803-1.43 5.392-4.112 5.783-2.68.39-5.184-1.563-5.594-4.366S6.558.442 9.239.05c2.679-.392 5.185 1.562 5.594 4.365",
  clipRule: "evenodd"
})));
export default SvgPuzzle;